{{#if skipNavigationAccessibility}}
<a id="skip-nav" role="link">{{t 'skipLinkText'}}</a> 
{{/if}}
{{#if srContent}}
  <div class="screen-reader-content" tabindex="-1" id="sr-content">
    <div>{{t srContent}}</div>
    <div>{{sr_skip_text}}</div>
  </div>
{{/if}}
<div id="timeout-modal-container"></div>
<div class="before-content"></div>
<div class="feedback" {{#if srContent}}aria-hidden="true"{{else}}aria-live="polite"{{/if}}></div>
<div id="page-container" class="page" {{#if srContent}}aria-hidden="true"{{/if}} role="main"></div>
<div class="actionbar" role="complementary"></div>
{{#if transcript}}
<button data-action="transcript" id="transcript_button" tabindex="0">{{t 'transcriptButton'}}</button>
<div class="site-transcript" tabindex="-1"></div>
{{/if}}
<button class="partner-content-btn-wrapper" data-toggle="modal" data-target="#print-modal" id="print-button" tabindex="0">{{t 'printButton'}}</button>
<div class="custom-content"></div>
